import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const PayOrderAppForceLogin = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/PayOrderApp/PayOrderAppProxy/PayOrderAppForceLogin'
    ).then(mod => ({
      default: mod.PayOrderAppForceLogin,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
